import JSRouter from "adminPage/JSRouter";
import Message from "base/Message";
import FormValidator from "base/FormValidator";
import Ajax from "base/Ajax";

JSRouter.register('login', new RegExp('^/forgotten/?$'), () => {
    FormValidator.attach($(".js-forgotten-password-form"), {inputOptions: {operator: 'your'}}).on("submit", function ($form) {
        let $btn = $form.find("button[type='submit']");
        if ($btn.is(".admin-btn--loading")) return;
        $btn.addClass("admin-btn--loading");

        Ajax.post("adminUsers", "login/forgotten", {
            email: $form.find(".js-email").val(),
        }, Ajax.ADMIN).then(function () {
            $(".js-forgotten-password-form").html(eotwJSXFactory('p', null, ["If an account with that email address exists you will receive an email with instructions to reset your password"]))
        }).catch(function (e) {
            new Message(e.message, "Couldn't reset your password");
            $btn.removeClass("admin-btn--loading");
        })
    });
});
